import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const ProductSliderContainer = styled.div`

width: 100%;
max-width: 540px;
height: ${props => props.no_additional_pictures ? '330px' : '600px'};

margin: 0 auto;
margin-bottom: 4rem;

@media (max-width: 400px) {
    height: ${props => props.no_additional_pictures ? '165px' : '295px'};
}

.additional-pictures {
    display: flex;
}
`
const MainPicture = styled.div`
    width: 100%;
    height: 330px;

    margin-bottom: 50px;

    background: url(${props => props.url}) no-repeat 50% 50%;
    background-size: contain;
    
    @media (max-width: 400px) {
        height: 165px;
        margin-bottom: 20px;
    }
`
const AdditionalPhoto = styled.div`
    width: 50%;
    height: 220px;

    :first-child {
        margin-right: 1rem;
    }

    background: url(${props => props.url}) no-repeat 50% 50%;
    background-size: cover;

    cursor: pointer;

    @media (max-width: 400px) {
        height: 110px;
    }
`

export const ProductSlider = ({ pictures }) => {

    const [picturesURLs, setPicturesURLs] = useState([])

    function handleClick(new_main_picture) {
        switch (new_main_picture) {
            case "1":
                {
                    const picturesURLs_copy = picturesURLs.slice(0, picturesURLs.length)

                    const first_picture = picturesURLs_copy.shift()
                    const new_picturesURLs = picturesURLs_copy
                    new_picturesURLs.push(first_picture)

                    setPicturesURLs(new_picturesURLs)
                }
                break;
            case "2":
                {
                    const picturesURLs_copy = picturesURLs.slice(0, picturesURLs.length)

                    const first_picture = picturesURLs_copy.pop()
                    const new_picturesURLs = picturesURLs_copy
                    new_picturesURLs.unshift(first_picture)

                    setPicturesURLs(new_picturesURLs)
                }
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const picturesURLs_default = []
        pictures.forEach(picture_file => {
            picturesURLs_default.push(picture_file.url)
        })
        setPicturesURLs(picturesURLs_default)
    }, [pictures])

    return (
        <ProductSliderContainer no_additional_pictures={ !picturesURLs[1] && !picturesURLs[2] } >
            <MainPicture url={picturesURLs[0]} />
            {picturesURLs[1] || picturesURLs[2]
                ? <div className="additional-pictures">
                    {picturesURLs[1] ? <AdditionalPhoto onClick={() => handleClick("1")} url={picturesURLs[1]} /> : null}
                    {picturesURLs[2] ? <AdditionalPhoto onClick={() => handleClick("2")} url={picturesURLs[2]} /> : null}
                </div>
                : null
            }
        </ProductSliderContainer>
    )
}